import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

api.interceptors.response.use(
  response => response,
  error => {
    // Ne radimo ništa s 401 - App.js sam hendla neprijavljenog usera
    return Promise.reject(error);
  }
);

export default api;
